<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <banner  :bgImage="bgImage"></banner>
    <section class="clientVoice">
	<div class="solutionCaseBox" style="padding-bottom:0;">
    	<div class="solutionConceptBox">
        	<div class="solutionConceptBoxR"><img src="../../../static/images/clientConceptPic5.jpg"></div>
            <div class="solutionConceptBoxL clientCaseBlue">
            	<div class="solutionConceptIn">
                	<div class="solutionConceptInTit">用心聆听客户的声音</div>
                    <div class="solutionConceptInConn">贴近应用的解决方案，丰富的实施经验，再加上良好的服务，睿哲科技帮助我们顺利完成了下一代互联网国家重大项目的建设，协助我们打造了行业领先的支持下一代互联网的数字电视交互系统。
                    	<p>——广电某公司案例</p>
                    </div>
                </div>
                <div class="clientCaseArr"></div>
            </div>
        </div>
    </div>
</section>
<section class="clientIncome">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit clientCaseFont">注重客户收益，想客户之所想</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<img src="../../../static/images/solutionDetailIcon14.png">
                <div class="solutionIncomeConn">支持IPv6的数字电视<br />交互系统为IPv6提供有<br />良好应用基础的行业应用</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon05.png">
                <div class="solutionIncomeConn">帮助数字电视交互系统<br />突破IPv4地址不足的制约，<br />满足海量用户终端的地址需求</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon07.png">
                <div class="solutionIncomeConn">突破目前的发展瓶颈，<br />降低升级成本和系统改造工作量</div>
            </li>
        </ul>
    </div>
</section>
<section class="clientChallenge">
	<div class="clientChallengeBox">
    	<img src="../../../static/images/clientChallengeBg2.jpg">
        <div class="clientChallengeConn">
        	<div class="clientChallengeTit">直面挑战，毫不畏惧</div>
            <ul class="clientChallengeList">
            	<li class="longBox" style="padding-bottom:42px;">
                	<div class="clientChallengeBoldTit">实现现有业务系统的平滑过渡</div>
                    <div class="clientChallengeMsg">项目计划构建百万用户级的IPv6的有线数字电视交互系统前端及改造完成支持百万级规模的IPv6用户认证支撑系统，需在不影响现有业务的前提下完成向IPv6的平滑过渡</div>
                </li>
                <li class="longBox" style="padding-bottom:42px;">
                	<div class="clientChallengeBoldTit">满足机顶盒终端的大规模部署</div>
                    <div class="clientChallengeMsg">项目计划在该地区部署商用20万台支持IPv6的机顶盒，需要配套稳定可靠的设备，支撑大流量的业务</div>
                </li>
                <li class="longBox">
                	<div class="clientChallengeBoldTit">构建稳定可靠的网络</div>
                    <div class="clientChallengeMsg">项目计划对该市有线电视交互网络骨干层和全市30个分机房城域数据汇聚层路由设备进行IPv6升级改造，需保证网络的稳定性，以保障客户体验</div>
                </li>
            </ul>
        </div>
	</div>
</section>
<section class="clientSolution">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit clientCaseFont">成熟的解决方案，难题迎刃而解</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<div class="clientSolutionTit">保障用户体验</div>
                <div class="clientSolutionConn">数字电视交互系统向IPv6演进应实现平滑过渡，保障现有IPv4业务不受影响，IPv6业务质量不低于IPv4业务质量</div>
            </li>
            <li>
            	<div class="clientSolutionTit">控制改造成本</div>
                <div class="clientSolutionConn">IPv6演进应保护现有投资，尽量降低升级成本和系统改造工作量</div>
            </li>
            <li>
            	<div class="clientSolutionTit">选择成熟技术</div>
                <div class="clientSolutionConn">升级改造技术应选择符合相关国内外标准的成熟技术，避免采用私有标准或非开放协议</div>
            </li>
        </ul>
    </div>
</section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage:'../../../static/images/clientDetailBanner.jpg?0219',
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./case";
.solutionCase {
}
</style>



// WEBPACK FOOTER //
// src/pages/case/caseDetail5.vue